module.exports = __webpack_public_path__ + "static/media/done-badge.d821413d.svg";